<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thêm mới danh mục sản phẩm</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col>
                                <b-form-group label="Tên danh mục cha:"
                                              label-for="parentId"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <!--<b-form-input type="text" id="parentId"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="category.parentId">
                                    </b-form-input>-->
                                    <treeselect class="col-6 no-padding" id="parentId"
                                                v-if="categories.length > 0" 
                                                v-model="category.parentId"
                                                placeholder="--- Chọn ---"
                                                :options="categories" />
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Tên danh mục:"
                                              label-for="name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              label-class="required">
                                    <b-form-input type="text" id="name"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.category.name.$model"
                                                  :state="$v.category.name.$dirty? !$v.category.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập tên danh mục
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Tiêu đề:"
                                              label-for="title"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              label-class="required">
                                    <b-form-input type="text" id="title"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.category.title.$model"
                                                  :state="$v.category.title.$dirty? !$v.category.title.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập tiêu đề
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Tên không dấu:"
                                              label-for="slug"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-input type="text" id="slug"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="category.slug">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Mô tả:"
                                              label-for="description"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              label-class="required">
                                    <b-form-input type="text" id="description"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.category.description.$model"
                                                  :state="$v.category.description.$dirty? !$v.category.description.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập mô tả
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Hình ảnh:"
                                              label-for="urlImage"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-file v-model="category.file"
                                                 class="col-6 no-padding"
                                                 accept="image/*"
                                                 browse-text="Chọn"
                                                 placeholder="Chọn tệp tải lên...">
                                    </b-form-file>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="MetaTitle:"
                                              label-for="name"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.category.metaTitle.$model"
                                                     :state=" $v.category.metaTitle.$model && $v.category.metaTitle.$dirty ? !$v.category.metaTitle.$error : null"
                                                     class="col-6" id="MetaTitle" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.category.metaTitle.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaKeywords:"
                                              label-for="MetaKeywords"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.category.metaKeywords.$model"
                                                     :state="$v.category.metaKeywords.$model && $v.category.metaKeywords.$dirty ? !$v.category.metaKeywords.$error : null"
                                                     class="col-6" id="MetaKeywords" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.category.metaKeywords.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaDescriptions:"
                                              label-for="MetaDescriptions"
                                              :label-cols="4"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.category.metaDescriptions.$model"
                                                     :state=" $v.category.metaDescriptions.$model && $v.category.metaDescriptions.$dirty ? !$v.category.metaDescriptions.$error : null"
                                                     class="col-6" id="MetaDescriptions" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.category.metaDescriptions.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Trạng thái:"
                                              label-align="right"
                                              label-for="status"
                                              :label-cols="4"
                                              :horizontal="true">
                                    <b-form-checkbox id="status" v-model="category.status" class="col-6 col-form-label"></b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Hiển thị trên trang chủ:"
                                              label-align="right"
                                              label-for="isshowhome"
                                              :label-cols="4"
                                              :horizontal="true">
                                    <b-form-checkbox id="isshowhome" v-model="category.isShowHome" class="col-6 col-form-label"></b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <b-button v-if="authorize(['ManageCategory'])" type="submit" variant="primary">Ghi lại</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel">Hủy</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { authorizationMixin } from '@/shared/mixins'
    import { required, sameAs, minLength, maxLength, helpers } from 'vuelidate/lib/validators'

    export default {
        name: 'CreateCategory',
        mixins: [validationMixin, authorizationMixin],
        data() {
            return {
                codeUnique: 'ok',
                category: {
                    name: null,
                    parentId: null,
                    title: null,
                    description: null,
                    slug: null,
                    urlImage: null,
                    metaTitle: null,
                    metaKeywords: null,
                    metaDescriptions: null,
                    status: false,
                    file: null
                },
                editing: false
            }
        },
        computed: {
            ...mapState({
                categories: (state, getters) => getters.categoryTree,
            })
        },
        validations: {
            category: {
                name: {
                    required,
                    maxLength: maxLength(128)
                },
                title: {
                    required,
                    maxLength: maxLength(128)
                },
                description: {
                    required,
                    maxLength: maxLength(128)
                },


                metaTitle: {
                    maxLength: maxLength(256)
                },
                metaKeywords: {
                    maxLength: maxLength(256)
                },
                metaDescriptions: {
                    maxLength: maxLength(256)
                },
            },
        },
        watch: {
            //'category.code'(newVal) {
            //    this.checkExistCode(newVal);
            //}
            'category.name'(value) {
                this.category.slug = value.convertslug();
            },
        },
        created() {
        },
        methods: {
            cancel() {
                this.$router.push({ path: '/master-data/categories/list' });
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    this.$services.upload('master-data/categories', this.category).done((id) => {
                        vm.$toastr.s('Tạo mới danh mục thành công');

                        vm.$store.dispatch('loadCategories').done(() => {
                            vm.cancel();
                        });
                    });
                }
            },
            //checkExistCode(newVal) {
            //    if (newVal) {
            //        //var vm = this;
            //        //this.$services.get(`master-data/existing-unit-types-code/${newVal}/${this.category.id || null}`).done(returnData => {
            //        //    if (!returnData) {
            //        //        this.codeUnique = "required";
            //        //    }
            //        //    else {
            //        //        this.codeUnique = "";
            //        //    }
            //        //});
            //    }
            //    else {
            //        this.codeUnique = "required";
            //    }
            //}
        }
    }
</script>
<style scoped>
</style>
